// Beige Professional design
const BeigeProfessionalDesign = {
  id: 'beige-professional',
  name: 'Beige',
  category: 'professional',
  description: 'Warm, neutral beige and taupe for a subtle style',
  colors: {
    primary: "#8a7967",    // Dark Beige/Taupe
    secondary: "#b8a99a",  // Medium Beige
    tertiary: "#dcd0c0",   // Light Beige
    quaternary: "#f5f1e9", // Cream/Off-white
    accent1: "#8a7967",    // Dark Beige/Taupe
    accent2: "#b8a99a",    // Medium Beige
    // Add other accents if needed
    text: "#4d4030",       // Dark Brown/Grey Text
    textSecondary: "#8a7967", // Medium Grey/Beige Secondary Text
    background: "#ffffff", // White background
    sidebarBackground: "#f5f1e9", // Cream/Off-white sidebar
    border: "#ffffff"     // Light Beige border
  },
};

export default BeigeProfessionalDesign; 